import React from "react";

export default function Header() {
  return (
    <header className="km-stars" style={styles.wrap}>
      <div style={styles.glow} aria-hidden="true" />
      <div style={styles.inner}>
        <div style={styles.eyebrow}>॥ वैदिक ज्योतिष ॥</div>
        <h1 style={styles.title}>Kundli Milan</h1>
        <p style={styles.tagline}>
          Precise birth charts and guna milan compatibility, read the way a
          Jyotishi would — grounded in your exact place, date and time of birth.
        </p>
      </div>
    </header>
  );
}

const styles = {
  wrap: {
    position: "relative",
    background: "radial-gradient(120% 160% at 50% -20%, #2f2260 0%, #170F2E 60%)",
    padding: "56px 20px 64px",
    overflow: "hidden",
    textAlign: "center",
  },
  glow: {
    position: "absolute", left: "50%", top: -80, width: 420, height: 420,
    transform: "translateX(-50%)", borderRadius: "50%",
    background: "radial-gradient(circle, rgba(232,169,74,0.25) 0%, rgba(232,169,74,0) 70%)",
    pointerEvents: "none",
  },
  inner: { position: "relative", maxWidth: 640, margin: "0 auto" },
  eyebrow: {
    fontFamily: "var(--font-serif)", color: "var(--gold-soft)", fontSize: 15,
    letterSpacing: 2, marginBottom: 10, opacity: 0.85,
  },
  title: {
    fontFamily: "var(--font-display)", color: "#fbf5e9", fontSize: "clamp(34px, 6vw, 52px)",
    margin: "0 0 14px", letterSpacing: 1,
  },
  tagline: {
    fontFamily: "var(--font-body)", color: "#c9bfe6", fontSize: 15.5,
    lineHeight: 1.7, margin: "0 auto", maxWidth: 520,
  },
};
